import * as moment from "moment";

export class GeoFenceEmployeePosition {
  geoFenceId:      number = -1 * moment().unix();
  employeeId:      string;
  jobId:           string;
  unitId:          string;
  active:          boolean;


  geoFenceName: string;

}
